import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';

export interface TipoColunaDinamicaProps {
    idTipoConfiguracaoPropriedade: number;
    dsTipoConfiguracaoPropriedade: string;
}

type TipoColunaDinamicaAutoCompleteProps = Pick<CissAutoCompleteProps, 'label' | 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange'>;

export function TipoColunaDinamicaAutoComplete({
    value,
    error,
    label = 'Tipo',
    multiple = false,
    sx,
    onChange,
}: TipoColunaDinamicaAutoCompleteProps) {
    return (
        <CissAutoComplete
            value={value}
            onChange={onChange}
            sx={sx}
            label={label}
            error={error}
            multiple={multiple}
            selectedStringTemplate="{dsTipoConfiguracaoPropriedade}"
            optionStringTemplate="{dsTipoConfiguracaoPropriedade}"
            isOptionEqualToValue={(option: TipoColunaDinamicaProps, value: TipoColunaDinamicaProps) =>
                option.idTipoConfiguracaoPropriedade === value.idTipoConfiguracaoPropriedade
            }
            requestOptions={{
                url: '/gestao/tipoconfiguracaopropriedade',
                sort: [{ property: 'idTipoConfiguracaoPropriedade', direction: 'ASC' }],
            }}
        />
    );
}
